import { render, staticRenderFns } from "./ILIndicatorsUsage.vue?vue&type=template&id=b2422cb6&scoped=true"
import script from "./ILIndicatorsUsage.vue?vue&type=script&lang=js"
export * from "./ILIndicatorsUsage.vue?vue&type=script&lang=js"
import style0 from "./ILIndicatorsUsage.vue?vue&type=style&index=0&id=b2422cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2422cb6",
  null
  
)

export default component.exports